export const View = {
  Use: 'view:use',
  Edit: (id) => `view:edit:${id}`,
};
export const ExtendedSearch = {
  Use: 'extendedsearch:use',
};
